import { useTheme } from "next-themes";
import { Sun, Moon, Monitor } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export const ThemeSettings = () => {
  const { theme, setTheme, resolvedTheme } = useTheme();
  
  const themes = [
    { value: "light", label: "Light", icon: Sun },
    { value: "dark", label: "Dark", icon: Moon },
    { value: "system", label: "System", icon: Monitor },
  ];
  
  const isActive = (value: string) => {
    if (value === 'system') {
      return theme === 'system';
    }
    return theme === value || (theme === 'system' && resolvedTheme === value);
  };
  
  return (
    <Card className="glass-card-strong">
      <CardHeader>
        <CardTitle className="text-gradient">Appearance</CardTitle>
        <CardDescription>
          Choose how Email2Contact looks to you. Select a theme or sync with your system.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 gap-3">
          {themes.map(({ value, label, icon: Icon }) => (
            <Button
              key={value}
              variant={isActive(value) ? "default" : "outline"}
              onClick={() => setTheme(value)}
              className={`flex flex-col items-center gap-2 h-auto py-4 transition-all hover-scale ${isActive(value) ? 'bg-gradient-to-r from-blue-600 to-purple-600 shadow-lg' : ''}`}
            >
              <Icon className="w-5 h-5" />
              <span className="text-sm">{label}</span>
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
